import { PayPerLeadCountyPrice } from "@containers/PayPerLead/interface";

export const DEFAULT_LEAD_LIMIT = 10;

export const getLeadLimit = (price: PayPerLeadCountyPrice) =>
  !price || price?.limit === null ? DEFAULT_LEAD_LIMIT : price?.limit || 0;
